import React, { useEffect } from "react";
import "./Faq.css";
import Accordion from "react-bootstrap/Accordion";
import Common_Back_Header from "../common_components/common_back_header/Common_Back_Header";
import { useDispatch, useSelector } from "react-redux";
import { getFaq } from "../../features/faq/Slice";
import parse from "html-react-parser";

const FAQ = () => {
  const faqSections = [
    {
      title: "General Questions",
      questions: [
        {
          question: "1. What is 'Majesty Mattress'?",
          answer:
            "'Majesty Mattress' is a platform that allows you to shop for a wide range of products, including all from the comfort of your home.",
        },
        {
          question: "2. How do I create an account?",
          answer:
            "Click on the signup button and complete the registration form.",
        },
      ],
    },
    {
      title: "Orders",
      questions: [
        {
          question: "3. Product Information and Availability",
          answer:
            "Product information and stock availability are displayed on each product page.",
        },
        {
          question: "4. Orders and Payments",
          answer:
            "You can manage orders and payments from your account dashboard.",
        },
      ],
    },
    {
      title: "Payments",
      questions: [
        {
          question: "5. What payment methods do you accept?",
          answer:
            "Product information and stock availability are displayed on each product page.",
        },
        {
          question: "6. Is my payment information secure?",
          answer:
            "You can manage orders and payments from your account dashboard.",
        },
      ],
    },
  ];

  const faq = useSelector((state) => state.faq.getfaq);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getFaq());
  }, [dispatch]);

  return (
    <div className="faq_section">
      {faq?.length > 0 ? (
        <div className="container">
          <div className="back_text">
            <Common_Back_Header />
          </div>

          <h2 className="faq_head">FAQs</h2>

          <div className="faq_holder">
            <Accordion defaultActiveKey="0">
              {faq?.map((faq, index) => (
                <Accordion.Item className="outer_accordion_item" eventKey="0">
                  <div className="heading_holder">
                    <h6>{faq?.name}</h6>
                  </div>
                  <div className="inner_accordion_holder">
                    {faq?.Faqs?.map((faqs) => (
                      <Accordion defaultActiveKey="0">
                        <Accordion.Item
                          className="inner_accordion_item"
                          eventKey={index}
                        >
                          <Accordion.Header>
                            {parse(faqs?.question)}
                          </Accordion.Header>
                          <Accordion.Body>{parse(faqs?.answer)}</Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    ))}
                  </div>
                </Accordion.Item>
              ))}
            </Accordion>
          </div>
        </div>
      ) : (
        <p style={{ textAlign: "center", fontWeight: "bold" }}>
          No Faq Available
        </p>
      )}
    </div>
  );
};

export default FAQ;
